module.exports = __webpack_public_path__ + "static/media/tcfwhitecolor.ed8833ee.svg";